import React from 'react';
import AppointmentReportsList from './apptreportslist';
import UploadReport from './uploadreport';

const AppointmentReports = () => {
    return (
        <div className='appointment-reports-container'>
            <div className="upload-actions">
                <UploadReport />
            </div>
            <div className="uploaded-docs">
                <AppointmentReportsList />
            </div>
        </div>
    );
};

export default AppointmentReports;
